var _path, _path2, _path3, _line, _rect, _line2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomFields = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 11.573,
    viewBox: "0 0 18 11.573",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.277.986V3.943H.986V.986H11.277M12.263,0H0V4.929H12.263Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.277,8.226V10.69H.986V8.226H11.277m.986-.986H0v4.436H12.263Z",
    transform: "translate(0 -0.103)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.162,4.594,13.21,2.642l.69-.7,1.242,1.242L17.478.72l.71.68Z",
    transform: "translate(-0.188 -0.01)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.697,
    y2: 3.628,
    transform: "translate(13.367 7.541)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.175,
    height: 0.986,
    transform: "translate(13.026 10.812) rotate(-44.37)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.618,
    y1: 3.706,
    transform: "translate(13.406 7.502)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.986,
    height: 5.175,
    transform: "translate(13.055 7.845) rotate(-44.4)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomFields);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom-fields.a3e4d1abb74f2f0c95a4403de286fed3.svg";